// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

export const formatCategories = (categoryString?: string): Record<string, string> => {
    if (!categoryString) {
        return {};
    }
    const categories = categoryString.split(",").map(category => category.trim());
    return categories.reduce((acc, category, index) => {
        acc[index === 0 ? "item_category" : `item_category${index + 1}`] = category;
        return acc;
    }, {} as Record<string, string>);
};
